import classNames from 'classnames';
import { memo, useMemo, useState } from 'react';

import type { ReactClassNameInterface } from '@/types/common';

import styles from './ChatApp.less';
import type { IChatContainerProps } from './components/chat-container';
import ChatContainer from './components/chat-container';
import type { IBasicInfo } from './context/BasicInfo';
import ContextBasicInfo from './context/BasicInfo';
import type { IConfig } from './types/common';
import { EAppMode } from './utils/const';

export interface IChatAppProps extends ReactClassNameInterface {
  chatContainer: IChatContainerProps;
}

function App(props: IChatAppProps): JSX.Element | null {
  const { chatContainer, className } = props;
  const { appMode, chatType = 'normal', sessionCb, config = {} as IConfig } = chatContainer;

  const { mindConfig } = config;
  const mindId = mindConfig.mindId;
  const mode = mindConfig.mode;
  const mindType = mindConfig.mindType;
  const userId = config.userId;
  const [sessionId, setSessionId] = useState<string>('');

  const inChatMode = appMode === EAppMode.CHAT_MODE;

  const inMobile = appMode === EAppMode.CHAT_MOBILE;

  const basicInfo: IBasicInfo = useMemo(() => {
    return {
      mindId,
      sessionId,
      appMode,
      configMode: appMode,
      inChatMode,
      userId,
      inMobile,
      isShared: chatContainer.inSharedHistory ?? false,
      mindType: mindType,
      mode: mode,
      chatType: chatType
    };
  }, [
    mindId,
    sessionId,
    appMode,
    userId,
    inChatMode,
    inMobile,
    chatContainer.inSharedHistory,
    mindType,
    mode,
    chatType
  ]);

  return (
    <ContextBasicInfo.Provider value={basicInfo}>
      <div
        className={classNames(
          'absolute left-0 flex flex-row w-full h-full',
          styles.container,
          className
        )}
      >
        <ChatContainer
          {...chatContainer}
          appMode={appMode}
          className={styles.chatContainer}
          sessionCb={(newMindId: string, newSessionId: string) => {
            setSessionId(newSessionId);
            sessionCb?.(newMindId, newSessionId);
          }}
        />
      </div>
    </ContextBasicInfo.Provider>
  );
}

export default memo(App);
